// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__2n5XJ","scroll":"sidebar_scroll__2Y4-w","logo":"sidebar_logo__3biSd","mobile":"sidebar_mobile__303Wu","separator":"sidebar_separator__27CYn"};